/*
 * Titan Infra — canonical company coordinates.
 * Single source of truth so we never fall out of sync across pages.
 */

export const COMPANY = {
  legalName: "Strategy Intelligence Solutions LTD",
  jurisdiction: "England & Wales",
  companyNumber: "16760736",
  address: {
    line1: "128 City Road",
    postcode: "EC1V 2NX",
    city: "London",
    country: "United Kingdom",
  },
  emails: {
    general: "contact@titan-infra.ai",
    investorRelations: "ir@titan-infra.ai",
  },
};

// Convenience one-liner for compact footers etc.
export const COMPANY_ONELINE = `${COMPANY.legalName} · Registered in ${COMPANY.jurisdiction} · Company No. ${COMPANY.companyNumber} · ${COMPANY.address.line1}, ${COMPANY.address.city} ${COMPANY.address.postcode}`;
